import React, { forwardRef } from 'react'

import { Loader } from '@elamajs/ui-kit'

import * as Styled from './Button.styled'
import { Props, Size, StaticProps, Variant, Width } from './Button.types'

const Button = forwardRef<HTMLButtonElement, Props>(
  (
    {
      size = Size.LARGE,
      variant = Variant.BLUE,
      width = Width.NARROW,
      isLoading,
      icon,
      iconLeft,
      iconRight,
      children,
      type,
      ...buttonProps
    },
    ref
  ) => (
    <Styled.Button
      ref={ref}
      size={size}
      variant={variant}
      width={width}
      hasIcon={Boolean(icon || iconRight || iconLeft)}
      type={type ?? 'button'}
      {...buttonProps}
    >
      {isLoading ? (
        <Styled.Loader isDisabled={buttonProps.disabled} as={Loader} />
      ) : (
        <>
          {iconLeft}
          {icon ?? <span>{children}</span>}
          {iconRight}
        </>
      )}
    </Styled.Button>
  )
)

Button.displayName = 'Button'

const ButtonWithStaticProps = Object.assign({}, Button, {
  Size: Size,
  Variant: Variant,
  Width: Width
} as StaticProps)

export default ButtonWithStaticProps
